

export enum Features {
  MULTIPLE_SELLERS = 'MULTIPLE_SELLERS',
  DEAL_GROUPS = 'DEAL_GROUPS',
  SELLER_TAGS = 'SELLER_TAGS',
  ATTACH_FILES = 'ATTACH_FILES',
}

const urlParams = new URLSearchParams(window.location.search);

const features = {
  [Features.MULTIPLE_SELLERS]: urlParams.get(Features.MULTIPLE_SELLERS) === 'true' || false,
  [Features.DEAL_GROUPS]: urlParams.get(Features.DEAL_GROUPS) === 'true' || true,
  [Features.SELLER_TAGS]: urlParams.get(Features.SELLER_TAGS) === 'true' || false,
  [Features.ATTACH_FILES]: urlParams.get(Features.ATTACH_FILES) === 'true' || false,
  // Add more feature flags as needed
};

export const isFeatureEnabled = (feature: Features): boolean => { 
  return features[feature] === true;
}